"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo, useState } from "react";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import MyStreamWaveMyVotesResetProgress from "./MyStreamWaveMyVotesResetProgress";
import { commonApiPost } from "@/services/api/common-api";
import { DropRateChangeRequest } from "@/entities/IDrop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "@/components/auth/Auth";
interface MyStreamWaveMyVotesResetProps {
  readonly haveDrops: boolean;
  readonly selected: Set<string>;
  readonly allItemsSelected: boolean;
  readonly onToggleSelectAll: () => void;
  readonly removeSelected: (dropId: string) => void;
  readonly setPausePolling: (pausePolling: boolean) => void;
}
const DEFAULT_DROP_RATE_CATEGORY = "Rep";
const MyStreamWaveMyVotesReset: React.FC<MyStreamWaveMyVotesResetProps> = t0 => {
  const $ = _c(31);
  const {
    haveDrops,
    selected,
    allItemsSelected,
    onToggleSelectAll,
    removeSelected,
    setPausePolling
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const [isResetting, setIsResetting] = useState(false);
  const [resetProgress, setResetProgress] = useState(0);
  const selectedCount = selected.size;
  let t1;
  if ($[0] !== removeSelected) {
    t1 = response => {
      removeSelected(response.id);
    };
    $[0] = removeSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setToast) {
    t2 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
      throw error;
    };
    $[2] = setToast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      mutationFn: _temp,
      onSuccess: t1,
      onError: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const rateChangeMutation = useMutation(t3);
  const [totalCount, setTotalCount] = useState(0);
  let t4;
  if ($[7] !== isResetting || $[8] !== rateChangeMutation || $[9] !== selected || $[10] !== selectedCount || $[11] !== setPausePolling) {
    t4 = async () => {
      if (!selectedCount || isResetting) {
        return;
      }
      setTotalCount(selectedCount);
      setPausePolling(true);
      setIsResetting(true);
      setResetProgress(0);
      const selectedDropIds = Array.from(selected);
      for (const dropId of selectedDropIds) {
        await rateChangeMutation.mutateAsync({
          dropId
        });
        setResetProgress(_temp2);
      }
      setIsResetting(false);
      setResetProgress(0);
      setPausePolling(false);
      setTotalCount(0);
    };
    $[7] = isResetting;
    $[8] = rateChangeMutation;
    $[9] = selected;
    $[10] = selectedCount;
    $[11] = setPausePolling;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleReset = t4;
  if (!haveDrops) {
    return null;
  }
  const t5 = allItemsSelected ? "Deselect All" : "Select All";
  let t6;
  if ($[13] !== isResetting || $[14] !== onToggleSelectAll || $[15] !== t5) {
    t6 = <SecondaryButton onClicked={onToggleSelectAll} size="sm" disabled={isResetting}>{t5}</SecondaryButton>;
    $[13] = isResetting;
    $[14] = onToggleSelectAll;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = !selectedCount || isResetting;
  const t8 = isResetting ? "Resetting..." : "Reset Votes";
  let t9;
  if ($[17] !== handleReset || $[18] !== t7 || $[19] !== t8) {
    t9 = <SecondaryButton onClicked={handleReset} size="sm" disabled={t7}>{t8}</SecondaryButton>;
    $[17] = handleReset;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-2">{t6}{t9}</div>;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isResetting || $[25] !== resetProgress || $[26] !== totalCount) {
    t11 = <MyStreamWaveMyVotesResetProgress isResetting={isResetting} resetProgress={resetProgress} totalCount={totalCount} />;
    $[24] = isResetting;
    $[25] = resetProgress;
    $[26] = totalCount;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <div className="tw-pl-1">{t10}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default MyStreamWaveMyVotesReset;
async function _temp(param) {
  return await commonApiPost({
    endpoint: `drops/${param.dropId}/ratings`,
    body: {
      rating: 0,
      category: DEFAULT_DROP_RATE_CATEGORY
    }
  });
}
function _temp2(prev) {
  return prev + 1;
}